import { render } from "./ThreeScene.vue?vue&type=template&id=61f5b89e"
import script from "./ThreeScene.vue?vue&type=script&lang=js"
export * from "./ThreeScene.vue?vue&type=script&lang=js"
script.render = render

export default script